import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import LoadingSwitchTransition from '@/components/LoadingSwitchTransition';
import PlaceholderLoading from '@/components/PlaceholderLoading';
import ProtocoloExecutadoSumario from '@/features/execucao/components/ProtocoloExecutadoSumario';
import { useExecucaoContext } from '@/features/execucao/providers/ExecucaoProvider';

const PlaceholderContent = () => (
  <PlaceholderLoading.Rect
    height={513}
    width="100%"
    style={{
      display: 'flex',
      borderRadius: 16,
    }}
  />
);

const SumarioProtocoloEnterprise: React.FC = () => {
  const history = useHistory();
  const [isLoadingProtocolo, setIsLoadingProtocolo] = useState(true);
  const [{ protocoloExecutado }] = useExecucaoContext();

  React.useEffect(() => {
    if (protocoloExecutado) {
      setIsLoadingProtocolo(false);
    }
  }, [protocoloExecutado]);

  React.useEffect(() => {
    if (!isLoadingProtocolo && !protocoloExecutado) {
      history.replace('/');
    }
  }, [history, isLoadingProtocolo, protocoloExecutado]);

  return (
    <LoadingSwitchTransition
      loading={
        protocoloExecutado?.contexto_integracao?.status_integracao === 'on-hold'
      }
      LoadingComponent={<PlaceholderContent />}
      style={{
        flex: 1,
      }}
    >
      <ProtocoloExecutadoSumario showBackToProtocol />
    </LoadingSwitchTransition>
  );
};

export default SumarioProtocoloEnterprise;
